module.exports = __webpack_public_path__ + "img/no-classes-icon.854f2b45.svg";